<mat-button-toggle-group>
  <mat-button-toggle
    (click)="toggle()"
    [checked]="enabled$ | async"
    [matTooltip]="tooltip"
  >
    <mat-icon>
      <span class="material-symbols-outlined"> rebase_edit </span>
    </mat-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
